module.exports = __webpack_public_path__ + "img/pank.a13a8a9b.jpg";